<template>
    <InformeCard id="venta_productos" name="venta_productos" collapsable="true" title="Productos">
        <ContentOrLoading>
            <div class="table-responsive" v-if="!loading">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>NOMBRE</th>
                            <th>UNIDADES</th>
                            <th>VENDIDAS</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(producto, index) in productos">
                            <tr :key="index">
                                <td>{{ producto.producto_name }}</td>
                                <td>{{ producto.unidades }}</td>
                                <td>{{ producto.precio | formatear_precio }}</td>
                                <td>{{ producto.total | formatear_precio }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: {
            event_id: {
                type: [Number, String],
                required: true
            },
            sesion_id: {
                type: [Number, String],
                default: null
            },
            taquillero_id: {
                type: [Number, String],
                default: null
            }
        },
        data() {
            return {
                productos: [],
                loading: false
            }
        },
        methods: {
            getProductos() {
                this.loading = true;
                const params = {
                    filters: {},
                    evento_id: this.event_id
                };

                if (this.sesion_id) {
                    params.filters.sesion_id = this.sesion_id;
                }

                if (this.taquillero_id) {
                    params.filters.taquillero_id = this.taquillero_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-productos-vendidos'), params).then(res => {
                    this.productos = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
        watch: {
            sesion_id() {
                this.getProductos();
            },
            taquillero_id() {
                this.getProductos();
            }
        },
        created() {
            this.getProductos();
        },
        components: {
            InformeCard
        }
    }
</script>
